<mat-accordion
  class="info-panel-accordion-container"
  [style.display]="accordionDisplay"
  hideToggle="true">
  <mat-expansion-panel
    (opened)="triggerOpenedPanelStateEvent(0)"
    (closed)="triggerClosedPanelStateEvent()"
    [expanded]="true"
    #matExpansionPanelElement>
    <mat-expansion-panel-header>
      <mat-panel-title>{{
        'wl.anz.important_info.header' | translate
      }}</mat-panel-title>
      <rd-shared-icon
        class="link-icon-image toggle-icon"
        [iconSymbol]="toggleIcon"
        [iconTheme]="'primary'"></rd-shared-icon>
    </mat-expansion-panel-header>
    <span [innerHTML]="currentTerms"> </span>
  </mat-expansion-panel>
</mat-accordion>
